import { defineMessages } from 'react-intl';

export const estimationItemsTableMessageDefinitions = defineMessages({
  estimationUnit: {
    id: 'estimationDetail.estimationItemsTable.estimationUnit',
    defaultMessage: 'Estimation Unit',
  },
  referenceNumber: {
    id: 'estimationDetail.estimationItemsTable.referenceNumber',
    defaultMessage: '#',
  },
  phaseLead: {
    id: 'estimationDetail.estimationItemsTable.phaseLead',
    defaultMessage: 'Phase Lead',
  },
  methodology: {
    id: 'estimationDetail.estimationItemsTable.methodology',
    defaultMessage: 'Methodology',
  },
  estimate: {
    id: 'estimationDetail.estimationItemsTable.estimate',
    defaultMessage: 'Estimate',
  },
  estimateCheck: {
    id: 'estimationDetail.estimationItemsTable.estimateCheck',
    defaultMessage: 'Estimate Check',
  },
  costSummary: {
    id: 'estimationDetail.estimationItemsTable.subtotal',
    defaultMessage: 'Subtotal',
  },
  included: {
    id: 'estimationDetail.estimationItemsTable.included',
    defaultMessage: 'Included',
  },
  detailsButton: {
    id: 'estimationDetail.estimationItemsTable.detailsButton',
    defaultMessage: 'Details',
  },
  assumptionsButton: {
    id: 'estimationDetail.estimationItemsTable.assumptionsButton',
    defaultMessage: 'Assumptions',
  },
  commentsButton: {
    id: 'estimationDetail.estimationItemsTable.commentsButton',
    defaultMessage: 'Comments',
  },
  addPhaseButton: {
    id: 'estimationDetail.estimationItemsTable.addPhaseButton',
    defaultMessage: 'Add Phase',
  },
  suggestion: {
    id: 'estimationDetail.estimationItemsTable.suggestion',
    defaultMessage: 'Suggestion',
  },
  emptyTableGroupName: {
    id: 'estimationDetail.estimationItemsTable.emptyTableGroupName',
    defaultMessage: 'Phase Name',
  },
  emptyTableText: {
    id: 'estimationDetail.estimationItemsTable.emptyTableText',
    defaultMessage: 'Currently there are no subitems for this phase.',
  },
  renameItem: {
    id: 'estimationDetail.estimationItemsTable.renameItem',
    defaultMessage: 'Rename',
  },
  saveItemName: {
    id: 'estimationDetail.estimationItemsTable.saveItemName',
    defaultMessage: 'Save name',
  },
  cancelItemRename: {
    id: 'estimationDetail.estimationItemsTable.cancelItemRename',
    defaultMessage: 'Cancel rename',
  },
});
